import { EVENTS_MAP, TEvents } from 'src/constants/events';
import { firebase } from './firebase';
import { gtm } from './gtm';

// type TEvents = typeof EVENTS;
class Logger {
  logEvent = (event: TEvents[keyof TEvents], data?: any) => {
    // Log to firebase
    if (EVENTS_MAP[event]) {
      firebase.logEvent(event, data);
    }
    // Log to Google Tag Manager
    if (EVENTS_MAP[event]) {
      gtm.logEvent(event, data);
    }
    return null;
  };

  log = (message: string, error?: any) => {
    console.info(message, error);
  };
}

const logger = new Logger();

export default logger;
